var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "thisStep" }, [
    _c("div", { staticClass: "frankinForm__stepTwo step" }, [
      _c(
        "div",
        { staticClass: "in container" },
        [
          _c("section", { staticClass: "formIntro" }, [
            _c("div", { staticClass: "in container" }, [
              _c("h4", [
                _vm._v(
                  "Step 2 of " +
                    _vm._s(_vm.$store.getters["QuoteForm/maxSteps"]) +
                    " - Your postage requirements"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Tell us about how you spend your postage and what you send, the more detail here the better as this will help us to more accurately determine the best machine for you and the additional postage savings available."
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Top tip: If you are currently in a contract, please have this handy to answer any questions our\n              Expert may have."
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-col",
                  attrs: { href: "/quotes-create?form=callback" }
                },
                [_vm._v("\n              Request a call back\n            ")]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.postage_period && _vm.postage_period == "no_info"
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "inputPanel",
                    class: {
                      inputPanel__error: _vm.invalidFields.letters_a_day
                    }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.letters_a_day,
                              expression: "letters_a_day"
                            },
                            {
                              name: "positive-numbers-only",
                              rawName: "v-positive-numbers-only"
                            }
                          ],
                          staticClass: "inputLarge",
                          attrs: {
                            type: "number",
                            name: "letteradayonaverage",
                            id: "letteradayonaverage",
                            placeholder: "Enter Value"
                          },
                          domProps: { value: _vm.letters_a_day },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.letters_a_day = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("error-modal", [
                      _vm._v(
                        "\n              Please confirm to the best of your ability the average number of letters you process each day.\n              "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              We understand this can often fluctuate so we suggest taking the sum of what you typically send across a monthly period and then divide by 21 to give an average based on working days in a month, this is a good starting point.\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("info-modal", [
                      _vm._v(
                        "\n              Please confirm to the best of your ability the average number of letters you process each day.\n              "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              We understand this can often fluctuate so we suggest taking the sum of what you typically send across a monthly period and then divide by 21 to give an average based on working days in a month, this is a good starting point.\n            "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "inputPanel" },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
                      },
                      [
                        _c(
                          "vue-slider",
                          _vm._b(
                            {
                              ref: "slider",
                              on: { "drag-end": _vm.updateClassPercentages },
                              model: {
                                value: _vm.sliderValue,
                                callback: function($$v) {
                                  _vm.sliderValue = $$v
                                },
                                expression: "sliderValue"
                              }
                            },
                            "vue-slider",
                            _vm.sliderOptions,
                            false
                          )
                        ),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "100%" } }, [
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.class1_postage_percentage_view) +
                                " %\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "right" } }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.class2_postage_percentage_view) +
                                " %\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("info-modal", [
                      _vm._v(
                        "\n              Please confirm here your average split between 1st and 2nd class postage e.g. 8 out of 10 letters send are 2nd class so 80% 2nd class and 20% 1st class. We understand you may not know exactly so use your experience and best judgement here.\n            "
                      )
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.postage_period && _vm.postage_period !== "no_info"
                ? _c("form-franking-form-letters")
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "inputPanel",
                  class: {
                    inputPanel__error: _vm.invalidFields.sendsBulkMailings
                  }
                },
                [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "inputPanel__col inputPanel__input" },
                    [
                      _c(
                        "ul",
                        { staticClass: "toggleBtns toggleBtns--inline" },
                        [
                          _c("li", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sendsBulkMailings,
                                  expression: "sendsBulkMailings"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: "campaignsyes",
                                name: "campaigns"
                              },
                              domProps: {
                                value: true,
                                checked: _vm._q(_vm.sendsBulkMailings, true)
                              },
                              on: {
                                change: function($event) {
                                  _vm.sendsBulkMailings = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "campaignsyes" } }, [
                              _vm._v("yes")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sendsBulkMailings,
                                  expression: "sendsBulkMailings"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: "campaignsno",
                                name: "campaigns"
                              },
                              domProps: {
                                value: false,
                                checked: _vm._q(_vm.sendsBulkMailings, false)
                              },
                              on: {
                                change: function($event) {
                                  _vm.sendsBulkMailings = false
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "campaignsno" } }, [
                              _vm._v("no")
                            ])
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("error-modal", [
                    _vm._v(
                      "\n              Lots of businesses send adhoc mailings for invoice runs, statement runs, marketing campaigns etc. Confirm here if you do any such mailings and the typical volumes and frequency of these.\n              "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n              This helps us configure the most suitable machine for you as well as the additional potential postage savings you could benefit from.\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("info-modal", [
                    _vm._v(
                      "\n              Lots of businesses send adhoc mailings for invoice runs, statement runs, marketing campaigns etc. Confirm here if you do any such mailings and the typical volumes and frequency of these.\n              "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n              This helps us configure the most suitable machine for you as well as the additional potential postage savings you could benefit from.\n            "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.sendsBulkMailings
                ? _c(
                    "div",
                    {
                      staticClass: "inputPanel sub-field-error",
                      class: {
                        inputPanel__error: _vm.invalidFields.mailing_volume
                      }
                    },
                    [
                      _c("error-modal", [
                        _vm._v(
                          "\n              Volume is required\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.mailing_volume,
                                expression: "mailing_volume"
                              },
                              {
                                name: "positive-numbers-only",
                                rawName: "v-positive-numbers-only"
                              }
                            ],
                            staticClass: "inputLarge inputReg inputReg--left",
                            attrs: {
                              type: "text",
                              name: "volumeuno",
                              id: "volumeuno",
                              placeholder: "Enter Value"
                            },
                            domProps: { value: _vm.mailing_volume },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.mailing_volume = $event.target.value
                              }
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sendsBulkMailings
                ? _c(
                    "div",
                    {
                      staticClass: "inputPanel sub-field-error",
                      class: {
                        inputPanel__error: _vm.invalidFields.mailing_frequency
                      }
                    },
                    [
                      _c("error-modal", [
                        _vm._v(
                          "\n              Frequency is required.\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mailing_frequency,
                                  expression: "mailing_frequency"
                                }
                              ],
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.mailing_frequency = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { disabled: "" },
                                  domProps: { value: null }
                                },
                                [_vm._v("Please Select")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.mailingFrequencies, function(
                                title,
                                value
                              ) {
                                return _c(
                                  "option",
                                  { domProps: { value: value } },
                                  [_vm._v(_vm._s(title))]
                                )
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "inputPanel",
              class: {
                inputPanel__error: _vm.invalidFields.average_packets_a_day
              }
            },
            [
              _vm._m(7),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.average_packets_a_day,
                        expression: "average_packets_a_day"
                      },
                      {
                        name: "positive-numbers-only",
                        rawName: "v-positive-numbers-only"
                      }
                    ],
                    staticClass: "inputReg inputReg--left",
                    attrs: {
                      type: "number",
                      name: "parcelsdoyousendaverage",
                      id: "parcelsdoyousendaverage",
                      placeholder: "Enter Value"
                    },
                    domProps: { value: _vm.average_packets_a_day },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.average_packets_a_day = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("error-modal", [
                _vm._v(
                  "\n            Please confirm to the best of your ability the average number of packets or parcels you process each day.\n            "
                ),
                _c("br"),
                _vm._v(
                  "\n            We understand this can often fluctuate so we suggest taking the sum of what you typically send across a monthly period and then divide by 21 to give an average based on working days in a month, this is a good starting point.\n          "
                )
              ]),
              _vm._v(" "),
              _c("info-modal", [
                _vm._v(
                  "\n            Please confirm to the best of your ability the average number of packets or parcels you process each day.\n            "
                ),
                _c("br"),
                _vm._v(
                  "\n            We understand this can often fluctuate so we suggest taking the sum of what you typically send across a monthly period and then divide by 21 to give an average based on working days in a month, this is a good starting point.\n          "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.needsAccountsSpendUnits
            ? _c(
                "div",
                {
                  staticClass: "inputPanel",
                  class: {
                    inputPanel__error: _vm.invalidFields.accounts_amount
                  }
                },
                [
                  _vm._m(8),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "inputPanel__col inputPanel__input inputPanel__input--groupFull"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accounts_amount,
                              expression: "accounts_amount"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.accounts_amount = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { disabled: "", selected: "" },
                              domProps: { value: null }
                            },
                            [_vm._v("Please Select")]
                          ),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 9 } }, [
                            _vm._v("Up to 9")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 10 } }, [
                            _vm._v("Up to 10")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 25 } }, [
                            _vm._v("Up to 25")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 30 } }, [
                            _vm._v("Up to 30")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 35 } }, [
                            _vm._v("Up to 35")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 50 } }, [
                            _vm._v("Up to 50")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 100 } }, [
                            _vm._v("Up to 100")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 150 } }, [
                            _vm._v("Up to 150")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 200 } }, [
                            _vm._v("Up to 200")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 300 } }, [
                            _vm._v("Up to 300")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 500 } }, [
                            _vm._v("Up to 500")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 1000 } }, [
                            _vm._v("Up to 1000")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 2000 } }, [
                            _vm._v("Up to 2000")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 3000 } }, [
                            _vm._v("Up to 3000")
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("error-modal", [
                    _vm._v(
                      "\n            **Important** The number of accounts chosen may limit your results as not all manufacturers provide up to 3000 accounts available.\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("info-modal", [
                    _vm._v(
                      "\n            **Important** The number of accounts chosen may limit your results as not all manufacturers provide up to 3000 accounts available.\n          "
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "inputPanel",
              class: {
                inputPanel__error:
                  _vm.invalidFields.lease_option_2 ||
                  _vm.invalidFields.lease_option_1
              }
            },
            [
              _vm._m(9),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "inputPanel__col inputPanel__input inputPanel__input--groupFull"
                },
                [
                  _c("span", { staticClass: "labelTop" }, [
                    _vm._v("Lease Option 1")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lease_option_1,
                          expression: "lease_option_1"
                        }
                      ],
                      attrs: { name: "quoteoptionsone" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.lease_option_1 = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: { disabled: "", selected: "" },
                          domProps: { value: null }
                        },
                        [_vm._v("Please Select")]
                      ),
                      _vm._v(" "),
                      _vm.lease_option_2 != 1
                        ? _c("option", { attrs: { value: "1" } }, [
                            _vm._v("1 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_2 != 2
                        ? _c("option", { attrs: { value: "2" } }, [
                            _vm._v("2 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_2 != 3
                        ? _c("option", { attrs: { value: "3" } }, [
                            _vm._v("3 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_2 != 4
                        ? _c("option", { attrs: { value: "4" } }, [
                            _vm._v("4 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_2 != 5
                        ? _c("option", { attrs: { value: "5" } }, [
                            _vm._v("5 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_2 != 6
                        ? _c("option", { attrs: { value: "6" } }, [
                            _vm._v("6 year lease term")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "labelTop" }, [
                    _vm._v("Lease Option 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lease_option_2,
                          expression: "lease_option_2"
                        }
                      ],
                      attrs: { name: "quoteoptionstwo" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.lease_option_2 = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: { disabled: "", selected: "" },
                          domProps: { value: null }
                        },
                        [_vm._v("Please Select")]
                      ),
                      _vm._v(" "),
                      _vm.lease_option_1 != 1
                        ? _c("option", { attrs: { value: "1" } }, [
                            _vm._v("1 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_1 != 2
                        ? _c("option", { attrs: { value: "2" } }, [
                            _vm._v("2 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_1 != 3
                        ? _c("option", { attrs: { value: "3" } }, [
                            _vm._v("3 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_1 != 4
                        ? _c("option", { attrs: { value: "4" } }, [
                            _vm._v("4 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_1 != 5
                        ? _c("option", { attrs: { value: "5" } }, [
                            _vm._v("5 year lease term")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lease_option_1 != 6
                        ? _c("option", { attrs: { value: "6" } }, [
                            _vm._v("6 year lease term")
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("error-modal", [
                _vm._v(
                  "\n            **Important**\n            Please provide two lease options. This will allow us to provide you with a price comparison on two lease terms to help you understand the best investment for you.\n          "
                )
              ]),
              _vm._v(" "),
              _c("info-modal", [
                _vm._v("\n            Choose your desired lease terms."),
                _c("br"),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "Top tip: The longer the lease the cheaper your costs and the higher your savings!"
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "inputPanel",
              class: { inputPanel__error: _vm.invalidFields.quote_confirmation }
            },
            [
              _c(
                "div",
                { staticClass: "inputPanel__col inputPanel__question" },
                [
                  _c("label", [
                    _vm._v("Would you like an option to purchase?")
                  ]),
                  _vm._v(" "),
                  _c("error-modal", [
                    _vm._v("\n              Required\n            ")
                  ]),
                  _vm._v(" "),
                  _vm._m(10)
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "inputPanel__col inputPanel__input" }, [
                _c("ul", { staticClass: "toggleBtns toggleBtns--inline" }, [
                  _c("li", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quote_confirmation,
                          expression: "quote_confirmation"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: "optiontopurchaseyes",
                        name: "optiontopurchase"
                      },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.quote_confirmation, true)
                      },
                      on: {
                        change: function($event) {
                          _vm.quote_confirmation = true
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "optiontopurchaseyes" } }, [
                      _vm._v("yes")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quote_confirmation,
                          expression: "quote_confirmation"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: "optiontopurchaseno",
                        name: "optiontopurchase"
                      },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.quote_confirmation, false)
                      },
                      on: {
                        change: function($event) {
                          _vm.quote_confirmation = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "optiontopurchaseno" } }, [
                      _vm._v("no")
                    ])
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "inputPanel",
              attrs: { id: "startOfContactDetails" }
            },
            [
              _vm._m(11),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.name,
                        expression: "name"
                      }
                    ],
                    staticClass: "inputLarge",
                    attrs: {
                      id: "savename",
                      type: "text",
                      name: "savename",
                      placeholder: "Name"
                    },
                    domProps: { value: _vm.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.name = $event.target.value
                      }
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "inputPanel" }, [
            _vm._m(12),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.company_name,
                      expression: "company_name"
                    }
                  ],
                  staticClass: "inputLarge",
                  attrs: {
                    id: "savecompany",
                    type: "text",
                    name: "savecompany",
                    placeholder: "Company name"
                  },
                  domProps: { value: _vm.company_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.company_name = $event.target.value
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inputPanel" }, [
            _vm._m(13),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contact_phone,
                      expression: "contact_phone"
                    }
                  ],
                  staticClass: "inputLarge",
                  attrs: {
                    id: "savetelephone",
                    type: "text",
                    name: "savetelephone",
                    placeholder: "Phone"
                  },
                  domProps: { value: _vm.contact_phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.contact_phone = $event.target.value
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { ref: "contact", staticClass: "inputPanel" }, [
            _vm._m(14),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "frmInline row",
                    staticStyle: { "justify-content": "center" }
                  },
                  [
                    _c("div", { staticStyle: { flex: "50%" } }, [
                      _c("div", { staticStyle: { "margin-bottom": "25px" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.preferences_email,
                              expression: "preferences_email"
                            }
                          ],
                          staticClass: "marketing contact_by_email_spec",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { id: "contactbyemailspec", type: "radio" },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.preferences_email, true)
                          },
                          on: {
                            click: function($event) {
                              _vm.preferences_email = !_vm.preferences_email
                            },
                            change: function($event) {
                              _vm.preferences_email = true
                            }
                          }
                        }),
                        _c("br"),
                        _c("span", [_vm._v("Email")])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.preferences_phone,
                              expression: "preferences_phone"
                            }
                          ],
                          staticClass: "marketing contact_by_phone_spec",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { id: "contactbyphonespec", type: "radio" },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.preferences_phone, true)
                          },
                          on: {
                            click: function($event) {
                              _vm.preferences_phone = !_vm.preferences_phone
                            },
                            change: function($event) {
                              _vm.preferences_phone = true
                            }
                          }
                        }),
                        _c("br"),
                        _c("span", [_vm._v("Phone")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { flex: "50%" } }, [
                      _c("div", { staticStyle: { "margin-bottom": "25px" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.preferences_mail,
                              expression: "preferences_mail"
                            }
                          ],
                          staticClass: "marketing contact_by_mail_spec",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { id: "contactbymailspec", type: "radio" },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.preferences_mail, true)
                          },
                          on: {
                            click: function($event) {
                              _vm.preferences_mail = !_vm.preferences_mail
                            },
                            change: function($event) {
                              _vm.preferences_mail = true
                            }
                          }
                        }),
                        _c("br"),
                        _c("span", [_vm._v("Mail")])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.preferences_sms,
                              expression: "preferences_sms"
                            }
                          ],
                          staticClass: "marketing contact_by_sms_spec",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { id: "contactbysmsspec", type: "radio" },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.preferences_sms, true)
                          },
                          on: {
                            click: function($event) {
                              _vm.preferences_sms = !_vm.preferences_sms
                            },
                            change: function($event) {
                              _vm.preferences_sms = true
                            }
                          }
                        }),
                        _c("br"),
                        _c("span", [_vm._v("SMS")])
                      ])
                    ])
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inputPanel" }, [
            _vm._m(15),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "inputPanel__col inputPanel__input",
                staticStyle: { "text-align": "center" }
              },
              [
                _c("input", {
                  staticClass: "btn btn-gradient",
                  staticStyle: {
                    border: "none",
                    padding: "10px 20px",
                    "border-radius": "10px"
                  },
                  attrs: {
                    type: "submit",
                    value: "Save & Continue",
                    id: "detailsStep2Submit"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.submitForm($event)
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inputPanel" }, [
            _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
              _c("input", {
                staticClass: "form-back-button",
                attrs: {
                  id: "inputPanelQuestion",
                  type: "submit",
                  value: "< Back"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.stepBack()
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.invalidFields && Object.keys(_vm.invalidFields).length > 0
            ? _c("invalid-fields")
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Not a fan of forms? Click here to request a call back and have one of our Mailing Experts\n              provide a quote for you."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [_vm._v("How many letters do you send a day on average?")]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n                  i\n                ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v(
          "Slide the percentage value to show the split between classes used\n                "
        ),
        _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
          _c(
            "div",
            { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
            [_vm._v("\n                    i\n                  ")]
          )
        ]),
        _vm._v(" "),
        _c("span")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v(
          "\n                We understand this may not be exact so please confirm to the best of your knowledge so we have a guide on usage.\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "100%" } }, [
      _c("div", { staticStyle: { float: "left" } }, [
        _vm._v("\n                  1st class\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { float: "right" } }, [
        _vm._v("\n                  2nd class\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { clear: "both" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v(
          "Do you send mail shots or bulk mailings in addition to the volumes noted above?"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n                  i\n                ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--right"
      },
      [
        _c(
          "label",
          {
            staticStyle: {
              "line-height": "45px",
              "padding-right": "30px",
              float: "right"
            }
          },
          [_vm._v("Volume")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "inputPanel__col inputPanel__info inputPanel__info--hide"
          },
          [
            _c(
              "div",
              { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
              [_vm._v("\n                  i\n                ")]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--right"
      },
      [
        _c(
          "label",
          {
            staticStyle: {
              "line-height": "45px",
              "padding-right": "30px",
              float: "right"
            }
          },
          [_vm._v("Frequency")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "inputPanel__col inputPanel__info inputPanel__info--hide"
          },
          [
            _c(
              "div",
              { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
              [_vm._v("\n                  i\n                ")]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v(
          "How many packets, parcels, recorded or special deliveries do you send per day on average?"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n                i\n              ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [_vm._v("How many accounts are required?")]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n                i\n              ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v("Choose your desired lease terms.\n              "),
        _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
          _c(
            "div",
            { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
            [_vm._v("\n                  i\n                ")]
          )
        ]),
        _vm._v(" "),
        _c("br")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v(
          "Top tip: The longer the lease the cheaper your costs and the higher potential savings!"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "inputPanel__col inputPanel__info inputPanel__info--hide"
      },
      [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n                i\n              ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [_vm._v("Your name")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "inputPanel__col inputPanel__info",
          staticStyle: { visibility: "hidden" }
        },
        [
          _c(
            "div",
            { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
            [_vm._v("\n                i\n              ")]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [_vm._v("Company name")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "inputPanel__col inputPanel__info",
          staticStyle: { visibility: "hidden" }
        },
        [
          _c(
            "div",
            { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
            [_vm._v("\n                i\n              ")]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [_vm._v("Contact phone number")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "inputPanel__col inputPanel__info",
          staticStyle: { visibility: "hidden" }
        },
        [
          _c(
            "div",
            { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
            [_vm._v("\n                i\n              ")]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v("\n              Contact preferences\n              "),
        _c(
          "div",
          {
            staticClass: "inputPanel__col inputPanel__info",
            staticStyle: { visibility: "hidden" }
          },
          [
            _c(
              "div",
              { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
              [_vm._v("\n                  i\n                ")]
            )
          ]
        ),
        _vm._v(" "),
        _c("br"),
        _c("br")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v(
          "We may send you news, offers, products and promotions we believe would be of interest to you. If you would like to opt out from our marketing communications please edit your contact preferences."
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "Themailingexpert.com takes data protection seriously as set out in our "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://themailingexpert.com/legal-privacy/",
              target: "_blank"
            }
          },
          [_vm._v("privacy policy")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a0c3ec5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a0c3ec5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Form/Step-2/Form.vue
// module id = null
// module chunks = 